import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    deleteHospitalBed,
    getAllHospitalBed,
    getHospitalBedById,
    pagingHospitalBed,
    saveOrUpdateHospitalBed
} from 'app/services/HospitalBedService';

import { HospitalBed } from "app/common/Model/HospitalBed";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { downloadTemplateHospitalBed, importFileExcelBed } from "app/services/ImportExcelService";

export default class HospitalBedStore {
    listAllHospitalBed = [];
    searchHospitalBed = new SearchObject();
    pageHospitalBed = null;
    selectedHospitalBed = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;
    openFormUpLoadFile = false

    constructor() {
        makeAutoObservable(this);
    }

    handleUpLoadFile = () => {
        this.openFormUpLoadFile = true
    }

    getAllHospitalBed = async () => {
        if (this.listAllHospitalBed?.length === 0 || this.recentlyUpdated === true) {
            return await getAllHospitalBed()
                .then((data) => {
                    this.listAllHospitalBed = data || [];
                    this.recentlyUpdated = false;
                })
                .catch(error => {
                    console.error(error);
                    toast.error("Lấy dữ liệu thất bại");
                })
        }
    }
    pagingHospitalBed = () => {
        pagingHospitalBed(this.searchHospitalBed)
            .then(({ data }) => {
                this.pageHospitalBed = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu giường bệnh có lỗi");
            });
    }

    importExcelBed = (file) => {
        importFileExcelBed(file).then(() => {
            toast.success("Nhập excel thành công")
            this.searchHospitalBed = {
                ...this.searchHospitalBed,
                pageIndex:1
            }
            this.pagingHospitalBed()

        }).catch(() => {
            toast.error("Nhập excel thất bại")
        }).
            finally(() => {
            this.handleClosePopup()
        })
    }

    handleChangeFormSearch = (searchHospitalBed) => {
        this.searchHospitalBed = checkSearchObject(this.searchHospitalBed, searchHospitalBed);
        this.pagingHospitalBed();
    }

    handleOpenFormCreateOrEdit = (hospitalBedId) => {
        if (Boolean(hospitalBedId)) {
            getHospitalBedById(hospitalBedId).then(({ data }) => {
                this.selectedHospitalBed = data;
                this.openFormCreateOrEdit = true;
            }).catch(function (error) {
                console.error(error);
                toast.error("Lấy dữ liệu không thành công");
            });
        } else {
            this.selectedHospitalBed = new HospitalBed();
            this.openFormCreateOrEdit = true;
        }
    }

    saveHospitalBed = async (healthCareBed, { setSubmitting }) => {

        return await saveOrUpdateHospitalBed(healthCareBed)
            .then(() => {
                this.recentlyUpdated = true;
                this.selectedHospitalBed = null;
                toast.success("Lưu giường bệnh thành công!");
                this.pagingHospitalBed();
                this.handleClosePopup();
                this.listAllHospitalBed = [];
            }).catch(function (error) {
                console.error(error);
                toast.error("Lưu giường bệnh thất bại!");
            }).finally(function () {
                setSubmitting(false);
            });
    }

    handleDeleteHospitalBed = (hospitalBedId) => {
        this.selectedHospitalBed = { id: hospitalBedId?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDeleteHospitalBed = () => deleteHospitalBed(this.selectedHospitalBed?.id)
        .then(() => {
            if (this.searchHospitalBed?.pageIndex > 1 && this.pageHospitalBed?.content?.length === 1) {
                this.searchHospitalBed.pageIndex -= 1;
            }
            toast.success("Xóa giường bệnh thành công!");
            this.pagingHospitalBed();
            this.recentlyUpdated = true;
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error("Xóa giường bệnh thất bại");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
        this.openFormUpLoadFile = false
    }


     handleDownloadExcelTemplate = async () => {
        try {
          const response = await downloadTemplateHospitalBed();
    
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "GIUONG.xlsx");
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          }
        } catch (error) {
          console.error("Error downloading template:", error);
        }
    }
    resetStore = () => {
        this.searchHospitalBed = new SearchObject();
        this.pageHospitalBed = null;
        this.selectedHospitalBed = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
        this.openFormUpLoadFile = false
    }



    //for choosing hospital bed popup in ChooseBedPopup.jsx 
    listBed = [];
    bedIdSet = null;

    isValidBed = bed => {
        if (bed && bed?.id) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addBed = bed => {
        if (!this.isValidBed(bed)) return;
        this.listBed.push(bed);
        this.bedIdSet.add(bed?.id);
    }

    initializeListBed = beds => {
        this.bedIdSet = new Set();
        this.listBed = [];
        if (beds && beds?.length > 0) {
            for (let i = 0; i < beds.length; i++) {
                this.addBed(beds[i]);
            }
        }
    }

    removeBed = bed => {
        if (!this.isValidBed(bed)) return;
        if (this.bedIdSet.has(bed?.id)) {
            this.bedIdSet.delete(bed?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExist = bed => {
        if (!this.isValidBed(bed)) return;
        return this.bedIdSet.has(bed?.id);
    }

    getBedIdSet = () => {
        return this.bedIdSet;
    }

    getListBed = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listBed && this.listBed?.length > 0) {
            for (let i = 0; i < this.listBed.length; i++) {
                const bed = this.listBed[i];
                if (this.isExist(bed) && !bufferIdSet.has(bed?.id)) {
                    data.push(bed);
                    bufferIdSet.add(bed?.id);
                }
            }
        }
        this.listBed = data;
        return data;
    }
    //end
}